import { createContext, useState, useContext } from "react";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import { format } from "date-fns";

import AppContext from "../contexts/AppContext";
import axios from "axios";

const CookieContext = createContext();

export const CookieContextProvider = ({ children }) => {
  const [cookies, setCookie, removeCookie] = useCookies();

  const { apiHost } = useContext(AppContext);
  const [axiosErr, setAxiosErr] = useState({ code: "", msg: "" });

  const setJwtCookies = (jwtAccess, jwtRefresh) => {
    setCookie("jwtAccess", jwtAccess, {
      expires: new Date(jwtDecode(jwtAccess).exp * 1000),
    });
    setCookie("jwtRefresh", jwtRefresh, {
      expires: new Date(jwtDecode(jwtAccess).exp * 1000),
    });

    console.log("[setCookieFromjwt](jwtAccess):%s", jwtAccess);
    console.log("[setCookieFromjwt](jwtRefresh):%s", jwtRefresh);

    // jwtAccessとjwtRefreshのシグネチャ
    // set cookie [jwtAccessVerifySignature, jwtRefreshVerifySignature]
    // setCookie("jwtAccessVerifySignature", jwtAccess.substr(-43));
    // setCookie("jwtRefreshVerifySignature", jwtRefresh.substr(-43));

    // jwtAccess全体像
    // set cookie [accessTokenExp, accessTokenExpTime,
    // accessTokenIat, accessTokenJti,
    // accessTokenUuid, accessTokenManagementCd]

    // accessTokenExp：認証期限のカウントダウンで使用
    setCookie("accessTokenExp", jwtDecode(jwtAccess).exp, {
      expires: new Date(jwtDecode(jwtAccess).exp * 1000),
    });

    // accessTokenExpTime：accessTokenの認証期限の年月日時分秒表記
    setCookie(
      "accessTokenExpTime",
      format(new Date(jwtDecode(jwtAccess).exp * 1000), "yyyy/MM/dd HH:mm:ss"),
      { expires: new Date(jwtDecode(jwtAccess).exp * 1000) },
    );

    // accessTokenUuid：uuid（verifyに使用）
    setCookie("accessTokenUuid", jwtDecode(jwtAccess).uuid, {
      expires: new Date(jwtDecode(jwtAccess).exp * 1000),
    });

    // accessTokenManagementCd：management_cd（verifyに使用）
    setCookie("accessTokenManagementCd", jwtDecode(jwtAccess).management_cd, {
      expires: new Date(jwtDecode(jwtAccess).exp * 1000),
    });

    // jwtRefresh全体像
    // set cookie [refreshTokenExp, refreshTokenExpTime,
    // refreshTokenIat, refreshTokenJti,

    // refreshTokenExp：認証期限のカウントダウンで使用
    setCookie("refreshTokenExp", jwtDecode(jwtRefresh).exp, {
      expires: new Date(jwtDecode(jwtAccess).exp * 1000),
    });

    // refreshTokenExpTime：refreshTokenの認証期限の年月日時分秒表記
    setCookie(
      "refreshTokenExpTime",
      format(new Date(jwtDecode(jwtRefresh).exp * 1000), "yyyy/MM/dd HH:mm:ss"),
      { expires: new Date(jwtDecode(jwtAccess).exp * 1000) },
    );
  };

  const refreshJwtCookies = async () => {
    const response = await axios
      .post(
        // `https://api.btime.online/user/token/refresh/`,
        `${apiHost}device/token/refresh/`,
        {
          refresh: cookies.jwtRefresh,
        },
      )
      .then(async (res) => {
        console.log("res.status:", res.status);

        // set cookie [jwtAccess, jwtRefresh]
        await setJwtCookies(res.data.access, res.data.refresh);

        console.log("cookies.jwtRefresh:", cookies.jwtRefresh);
        console.log("res.data.refresh:", res.data.refresh);
      })
      .catch((err) => {
        if (err.response) {
          // client received an error response (5xx, 4xx)
          console.log("err.response:", err.response);
          console.log("err.response.status:", err.response.status);
          console.log("err.response.data.detail:", err.response.data.detail);

          // エラーの場合、cookieを削除して、トップ画面へ遷移
          removeJwtCookies();

          setAxiosErr({
            ...axiosErr,
            code: err.response.status,
            msg: "有効なRefreshTokenではありません",
          });
          window.location.href = "/";
        } else if (err.request) {
          // client never received a response, or request never left
          console.log("err.request:", err.request);

          // エラーの場合、cookieを削除して、トップ画面へ遷移
          removeJwtCookies();

          setAxiosErr({
            ...axiosErr,
            code: "",
            msg: "エラーが発生しました",
          });
          window.location.href = "/";
        } else {
          // anything else
          console.log("err:", err);

          // エラーの場合、cookieを削除して、トップ画面へ遷移
          removeJwtCookies();

          setAxiosErr({
            ...axiosErr,
            code: "",
            msg: "エラーが発生しました",
          });
          window.location.href = "/";
        }
      });
  };

  const removeJwtCookies = () => {
    removeCookie("jwtAccess");
    removeCookie("jwtRefresh");
    removeCookie("accessTokenExp");
    removeCookie("accessTokenExpTime");
    removeCookie("accessTokenUuid");
    removeCookie("accessTokenManagementCd");
    removeCookie("refreshTokenExp");
    removeCookie("refreshTokenExpTime");
  };

  const setWachaBizCookies = (uuid) => {
    let expiresDate = new Date();
    // setCookie("uuid", format(Date.now() + (365 * 24 * 60 * 60 * 1000), "yyyy-MM-dd HH:mm:ss"), {
    // setCookie("todayOfNextYear", format(Date.now() + (365 * 24 * 60 * 60 * 1000), "EEE, dd LLL yyyy HH:mm:ss 'GMT'"), {
    setCookie("todayOfNextYear", Date.now() + 365 * 24 * 60 * 60 * 1000, {
      // expires: format(Date.now() + (365 * 24 * 60 * 60 * 1000), "EEE, dd LLL yyyy HH:mm:ss 'GMT'"),
      // expires: format(Date.now() + (365 * 24 * 60 * 60 * 1000), "yyyy-MM-dd HH:mm:ss"),
      // expires: format(expiresDate + (365 * 24 * 60 * 60 * 1000), "yyyy-MM-dd HH:mm:ss"),
      // expires: format(expiresDate.getFullYear(), "yyyy-MM-dd HH:mm:ss"),
      // expires: (Date.now() + (365 * 24 * 60 * 60 * 1000)).toString(),
      // expires: (expiresDate.setTime(expiresDate.getTime()) + (365 * 24 * 60 * 60 * 1000)).toUTCString(),
      // maxAge: （秒）
      maxAge: 3600,
    });
    setCookie("uuid", uuid, {
      // maxAge: （秒）
      maxAge: 3600,
    });
    // setCookie("ip_addr", ip_addr, {
    //   maxAge: 3600,
    // });

    // // 出力フォーマット
    // const curTime = format(Date.now(), "yyyy/MM/dd(" + youbi + ") HH:mm:ss");

    // console.log("[setCookieFromjwt](jwtAccess):%s", format(Date.now() + (365 * 24 * 60 * 60 * 1000), "ddd, dd MMM yyyy HH:mm:ss GMT"),);
    // console.log("[setCookieFromjwt](jwtAccess):%s", (Date.now() + (365 * 24 * 60 * 60 * 1000)).toUTCString(),);
  };

  // 文字色と背景色設定
  // uuid先頭6文字をrgbとする
  // setCookie(
  //   "usernameFontColor",
  //   "#" + jwtDecode(jwtAccess).uuid.slice(0, 6),
  //   {
  //     expires: new Date(jwtDecode(jwtAccess).exp * 1000),
  //   }
  // );

  return (
    <CookieContext.Provider
      value={{
        cookies,
        setJwtCookies,
        refreshJwtCookies,
        removeJwtCookies,
        setWachaBizCookies,
      }}
    >
      {children}
    </CookieContext.Provider>
  );
};

export default CookieContext;
